import { render, staticRenderFns } from "./ConventionTeaserTerritories.vue?vue&type=template&id=106e8cc7&scoped=true"
import script from "./ConventionTeaserTerritories.vue?vue&type=script&lang=js"
export * from "./ConventionTeaserTerritories.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaserTerritories.vue?vue&type=style&index=0&id=106e8cc7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106e8cc7",
  null
  
)

export default component.exports